import Super from '@simplepractice/ember-messaging-client/adapters/messaging-message';

export default Super.extend({});
